export enum ChatbotStatus {
  Live = 0,
  InTesting = 1,
}
export enum ChatbotStatusLabel {
  Live = 'Live',
  InTesting = 'In Testing',
}
